
















































































































import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import {
  PaymentMethodType,
  SelectedPaymentMethod
} from "@/models/selectPaymentMethod";
import { GatewayContext, GatewayStoreType } from "@/data/enums/gateway";
import { Location as VueLocation } from "vue-router";
import { IClient } from "@/models/clients";
import { IAccount } from "@/models/accounts";
import { IBrand } from "@/models/brands";
import { UUID } from "@/data/enums";
import { ICurrency } from "@/models/constants";
import { IPaymentDetail } from "@/models/paymentDetails";
import { IGateway } from "@/models/gateways";

@Component({
  components: {
    "payment-type": () =>
      import("@/components/app/global/payments/paymentType/index.vue"),
    "brand-gateways": () =>
      import("@/components/app/global/payments/brandGateways/index.vue"),
    "stored-payment-methods": () =>
      import("@/components/app/global/payments/storedPaymentMethods.vue"),
    "wallet-input": () =>
      import("@/components/app/global/wallets/walletInput.vue")
  }
})
export default class SelectPaymentMethod extends Vue {
  @Prop({ default: null })
  public value!: SelectedPaymentMethod | null;

  @Prop({ default: "" })
  public clientId!: IClient["id"];

  @Prop({ default: "" })
  public accountId!: IAccount["id"];

  @Prop({ default: 0 })
  public totalAmount!: number;

  @Prop({ default: UUID.ORG })
  public brandId!: IBrand["id"];

  @Prop({ default: "" })
  public currencyId!: ICurrency["id"];

  @Prop({ default: "" })
  public currencyCode!: ICurrency["code"];

  @Prop({ default: false })
  public onlineGatewaysOnly!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: "" })
  public cardHolderName!: string;

  @Prop({ default: false })
  public hasPayLater!: boolean;

  @Prop({ default: false })
  public hasManualPayment!: boolean;

  @Prop({ default: false })
  public hasPartialPayment!: boolean;

  @Prop({ default: false })
  public canChangeManualPaymentAmount!: boolean;

  @Prop({ default: true })
  public showManualAmountInput!: boolean;

  @Prop({ default: false })
  public autoSelectFirstGateway!: boolean;

  @Prop({ default: true })
  public autoSelectFirstStoredPaymentMethod!: boolean;

  @Prop({ default: "" })
  public preselectedGatewayId!: IGateway["id"];

  @Prop({ default: "" })
  public preselectedStoredPaymentMethodId!: IPaymentDetail["id"];

  @Prop({ default: null })
  public externalAuthReturnLocation!: VueLocation;

  @Prop({ default: () => [] })
  public readonly excludedGatewayStoreTypes!: GatewayStoreType[];

  @Prop({ required: true })
  public gatewayContext!: GatewayContext;

  @Prop({ default: true })
  public showAddressField!: boolean;

  @Ref()
  public brandGateways!: any;

  public useAccountCredit = true;
  public walletAmount = 0;
  public totalAmountNew = 0;
  public walletAmountAvailable = 0;
  public walletAmountAvailableFormatted = "";
  public walletLoading = true;
  public loadStoredPaymentMethodsAndBrandGateways = false;
  public gatewaysLoading = true;
  public storedPaymentMethodsLoading = true;

  public created() {
    if (!this.accountId) {
      this.walletLoading = false;
      this.loadStoredPaymentMethodsAndBrandGateways = true;
    }
    if (!this.clientId) {
      this.storedPaymentMethodsLoading = false;
    }
  }

  // Getters
  public get showPaymentType() {
    return this.hasPartialPayment || this.hasPayLater || this.hasManualPayment;
  }

  public get needsMoreThanWalletAmount() {
    return (
      (this.walletAmount || 0) < this.totalAmountNew || !this.totalAmountNew
    );
  }

  public get brandGatewayBindings() {
    return {
      autoSelectFirst: this.autoSelectFirstGateway,
      brandId: this.brandId,
      clientId: this.clientId,
      clientName: this.cardHolderName,
      currencyCode: this.currencyCode,
      currencyId: this.currencyId,
      excludedGatewayStoreTypes: this.excludedGatewayStoreTypes,
      externalAuthReturnLocation: this.externalAuthReturnLocation,
      gatewayContext: this.gatewayContext,
      isDisabled: this.isDisabled,
      onlineOnly: this.onlineGatewaysOnly,
      preselectedId: this.preselectedGatewayId,
      showAddressField: this.showAddressField,
      totalAmount: this.totalAmount ? this.totalAmount - this.walletAmount : 0,
      value: this.value
    };
  }

  public buildInput(
    value: SelectedPaymentMethod | null
  ): SelectedPaymentMethod | null {
    const hasPaymentMethod =
      !this.$_.isEmpty(value) && this.needsMoreThanWalletAmount;
    const hasWalletAmount = this.$_.isEmpty(this.walletAmount);
    if (!hasPaymentMethod && !hasWalletAmount) {
      return null;
    }
    return this.$_.merge(
      {},
      hasPaymentMethod ? value : {},
      this.totalAmountNew ? { amount: this.totalAmountNew } : {},
      hasWalletAmount ? { walletAmount: this.walletAmount } : {}
    ) as SelectedPaymentMethod;
  }

  public emitInput(value) {
    this.$emit("input", this.buildInput(value));
  }

  @Watch("useAccountCredit", { immediate: true })
  public onUseAccountCreditChanged() {
    this.setWalletAmount();
  }

  @Watch("walletAmount")
  public onWalletAmountChange() {
    this.emitInput(this.value);
    this.toggleStoredPaymentsAndBrandGatewaysIfNeeded();
  }

  public toggleStoredPaymentsAndBrandGatewaysIfNeeded() {
    if (this.needsMoreThanWalletAmount) {
      this.loadStoredPaymentMethodsAndBrandGateways = true;
    }
  }

  @Watch("totalAmount", { immediate: true })
  public onTotalAmountChange() {
    this.totalAmountNew = this.totalAmount;
    if (this.value) {
      this.emitInput(this.value);
    }
  }

  @Watch("totalAmountNew", { immediate: true })
  public onTotalAmountNewChange() {
    this.setWalletAmount();
    if (this.value) {
      this.emitInput(this.value);
    }
  }

  public onWalletLoaded() {
    this.walletLoading = false;
    this.setWalletAmount();
    if (!this.walletAmount) {
      this.toggleStoredPaymentsAndBrandGatewaysIfNeeded();
    }

    // wait for th watcher
    this.$nextTick(() => {
      if (
        !this.loadStoredPaymentMethodsAndBrandGateways ||
        !this.needsMoreThanWalletAmount ||
        this.isManualOrPayLater
      ) {
        this.storedPaymentMethodsLoading = false;
        this.gatewaysLoading = false;
      }
    });
  }

  public get isManualOrPayLater() {
    return [
      PaymentMethodType.MANUAL_PAYMENT,
      PaymentMethodType.PAY_LATER
    ].includes(this.value?.type as PaymentMethodType);
  }

  public setWalletAmount() {
    this.walletAmount = this.useAccountCredit
      ? Math.min(this.totalAmountNew, this.walletAmountAvailable || 0) // Could be NaN
      : 0;
  }

  public onSelectPaymentMethodFromPaymentType(
    value: SelectedPaymentMethod | null
  ) {
    if (this.brandGateways) {
      this.brandGateways.selectedGateway = null;
    }
    if (value) {
      this.$emit("input", value);
      return;
    }
    this.totalAmountNew = this.totalAmount;
    this.emitInput(value);
  }
}
